<template>
    <div class="form-container" v-if="value">
        <v-divider class="primary border-2"></v-divider>
        <div class="py-20 px-md-10 py-md-36">
            <div class="mt-n8 mt-md-n14">
                <myinfo-row label="이름"> {{ form?.meta?.name || "-" }} </myinfo-row>

                <myinfo-row label="연락처"> {{ form?.meta?.phone || "-" }} </myinfo-row>
                <myinfo-row label="이메일"> {{ form?.meta?.email || "-" }} </myinfo-row>
            </div>
        </div>

        <div class="py-20 px-md-10 py-md-36">
            <div class="mt-n8 mt-md-n14">
                <myinfo-row label="제목"> {{ form?.subject || "-" }} </myinfo-row>
                <myinfo-row label="내용"> {{ form?.content || "-" }} </myinfo-row>
            </div>
        </div>

        <v-card tile elevation="0" class="grey-ef">
            <v-card-text class="pa-16 pa-md-24">
                <div class="page-text" v-html="form?.reply || '답변 내용이 없습니다.'"></div>
            </v-card-text>
        </v-card>

        <!-- 하단버튼 -->
        <div class="mt-30 mt-md-50">
            <div class="v-btn--group v-btn--group--large">
                <v-btn x-large outlined color="grey-cb" class="w-100 mw-220px" @click="$router.go(-1)"><span class="primary--text">목록으로</span></v-btn>
                <!-- <v-btn x-large color="primary" class="w-100 mw-220px" @click="$emit('save')">위탁신청</v-btn> -->
            </div>
        </div>
    </div>
</template>

<script>
import MyinfoRow from "@/components/client/mypage/myinfo-row.vue";
import ImagePopup from "@/components/console/dumb/image-popup.vue";
import BidsItemImgs from "@/components/client/mypage/bids-item-imgs.vue";

export default {
    components: {
        MyinfoRow,
        ImagePopup,
        BidsItemImgs,
    },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            form: this.$props.value,
        };
    },
    watch: {
        value() {
            this.form = this.value;
        },
    },
    methods: {
        input() {
            this.$emit("input", this.form);
        },
    },
};
</script>
